import { handleDeviceTitle } from '@/components/lib';
import { EDeviceInfoModule, ICloudService, IDeviceProfile, IGetAccountDeviceArgs, IGetAccountDeviceListArgs, IGetAccountDeviceRes, ISetDeviceAiFeaturesArgs, TCloudDevice, TGetAccountDeviceItemRes } from '@reolink-cloud/interface';
import { httpManager as http } from '@/plugins/HttpManager';
import { getIPlan } from './cart';
import { getSubDeviceList } from './subscriptions';
import { config } from '@/config/reolink';

export const getDeviceList = async ( args: IGetAccountDeviceListArgs ): Promise<IGetAccountDeviceRes> => {

    const { data } = await http.post<IGetAccountDeviceRes>( `/cloud/devices/items/list-query`, args );

    return data;

};

export const getDevice = async ( args: IGetAccountDeviceArgs ): Promise<TGetAccountDeviceItemRes> => {

    const { data } = await http.post<TGetAccountDeviceItemRes>( `/cloud/devices/items/query`, args );

    return data;

};

/**
 * 获取TCloudDeviceList，注意includes模块会自动添加获取title的必要模块, 注意调用前需要先调用productManager的update
 * @param args getDeviceList arg
 * @param cloudServiceList 传入则返回所有cloudService形成的列表
 * @returns
 */
export const getTCloudDeviceList = async ( args: IGetAccountDeviceListArgs, cloudServiceList?: ICloudService[] ): Promise<TCloudDevice[]> => {

    const includes = new Set<IGetAccountDeviceListArgs['includes'][0]>( [
        EDeviceInfoModule.ONLINE_CONFIG,
        EDeviceInfoModule.CONFIG_TEMPLATE,
        EDeviceInfoModule.MODEL,
        EDeviceInfoModule.CHANNELS,
        EDeviceInfoModule.CLOUDSERVICES
    ] );
    for ( const infoModule of args.includes ) {

        includes.add( infoModule );

    }

    const [getDeviceListRes, subDeviceList] = await Promise.all( [
        getDeviceList({ ...args, includes: Array.from( includes ) }),
        getSubDeviceList(),
    ] );

    if ( cloudServiceList ) {

        cloudServiceList.push( ...Object.values( getDeviceListRes.cloudServices ?? {}));

    }

    for ( const cloudService of Object.values( getDeviceListRes.cloudServices ?? {})) {

        cloudService.planInfo = await getIPlan( cloudService.plan, args.lang );

    }
    const deviceList: TCloudDevice[] = [];
    for ( const device of getDeviceListRes.items ) {

        const finalDeviceInfo: TCloudDevice = { ...device, imageRetentionDays: 0, videoRetentionDays: 0, boundStatus: 'unassociated', cloudServiceInstances: {}, title: '', currentSubscription: '' };
        const subDevice = subDeviceList.find( subDevice => subDevice.uid == device.uid );
        if ( subDevice ) {

            finalDeviceInfo.boundStatus = subDevice.status;
            finalDeviceInfo.imageRetentionDays = subDevice.imageRetentionDays;
            finalDeviceInfo.videoRetentionDays = subDevice.videoRetentionDays;
            finalDeviceInfo.currentSubscription = subDevice.subscription;

        }

        for ( const cloudServiceId of device.cloudServices ?? [] ) {

            if ( getDeviceListRes.cloudServices ) {

                const cloudService = ( getDeviceListRes.cloudServices )[cloudServiceId];
                finalDeviceInfo.cloudServiceInstances![cloudServiceId] = cloudService;
                if ( cloudServiceId === finalDeviceInfo.currentSubscription ) {

                    finalDeviceInfo.plan = cloudService.planInfo;
                    finalDeviceInfo.planName = cloudService.planInfo?.series?.i18n.name;

                }

            }

        }

        const title = handleDeviceTitle( finalDeviceInfo );

        finalDeviceInfo.title = title;

        deviceList.push( finalDeviceInfo );

    }

    return deviceList;

};

export const getTCloudDevice = async ( args: IGetAccountDeviceArgs ): Promise<TCloudDevice> => {

    const includes = new Set<IGetAccountDeviceArgs['includes'][0]>( [
        EDeviceInfoModule.ONLINE_CONFIG,
        EDeviceInfoModule.CONFIG_TEMPLATE,
        EDeviceInfoModule.MODEL,
        EDeviceInfoModule.CHANNELS,
        EDeviceInfoModule.CLOUDSERVICES
    ] );
    for ( const infoModule of args.includes ) {

        includes.add( infoModule );

    }
    const [getDeviceRes, subDeviceList, ] = await Promise.all( [
        getDevice({ ...args, includes: Array.from( includes ) }),
        getSubDeviceList(),
    ] );

    for ( const cloudService of Object.values( getDeviceRes.services ?? {})) {

        cloudService.planInfo = await getIPlan( cloudService.plan, args.lang );

    }
    const device = getDeviceRes;
    const subDevice = subDeviceList.find( subDevice => subDevice.uid == device.uid );
    const finalDeviceInfo: TCloudDevice = { ...device, imageRetentionDays: 0, videoRetentionDays: 0, boundStatus: 'unassociated', cloudServiceInstances: {}, title: '', currentSubscription: '' };
    if ( subDevice ) {

        finalDeviceInfo.boundStatus = subDevice.status;
        finalDeviceInfo.imageRetentionDays = subDevice.imageRetentionDays;
        finalDeviceInfo.videoRetentionDays = subDevice.videoRetentionDays;
        finalDeviceInfo.currentSubscription = subDevice.subscription;

    }

    for ( const cloudServiceId of device.cloudServices ?? [] ) {

        if ( getDeviceRes.services ) {

            const cloudService = ( getDeviceRes.services )[cloudServiceId];
            finalDeviceInfo.cloudServiceInstances![cloudServiceId] = cloudService;
            if ( cloudServiceId === finalDeviceInfo.currentSubscription ) {

                finalDeviceInfo.plan = cloudService.planInfo;
                finalDeviceInfo.planName = cloudService.planInfo?.series?.i18n.name;

            }

        }

    }

    const title = handleDeviceTitle( finalDeviceInfo );
    finalDeviceInfo.title = title;

    return finalDeviceInfo;

};

export const getDeviceAiFeatureStatus = async ( uid: string ): Promise<boolean> => {

    const { data } = await http.get<boolean>( `/cloud/devices/ai-feature/status?uid=${uid}` );
    return data;

};

export const setDeviceAiFeature = async ( args: ISetDeviceAiFeaturesArgs ): Promise<void> => {

    await http.patch( '/cloud/subscriptions/devices', args );

};

export const getDeviceProfile = async ( uid: string ): Promise<IDeviceProfile> => {

    const { data } = await http.get<IDeviceProfile>( `/devices/${uid}/profile`, {
        baseURL: config.baseUrl + 'v1.0/'
    });

    return data;

};
